import { IScopeClause, updateScopeClause } from "@/api";
import {
    ConfirmationDialog,
    IConfirmationDialogProps,
} from "@/components/shared/dialogs/ConfirmationDialog";

import { Link } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";
import { enqueueSnackbar } from "notistack";

interface IProps {
    /**
     * The scope clause to remove guidance for
     */
    scopeClause: IScopeClause;
}

export const RemoveGuidance = ({ scopeClause }: IProps) => {
    const { open } = useDialogs();
    const queryClient = useQueryClient();

    const { mutate } = useMutation({
        mutationFn: async (guidance: string) =>
            updateScopeClause(scopeClause.scope_id, scopeClause.id, guidance),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["frontend-scope"],
            });
            queryClient.invalidateQueries({
                queryKey: ["frontend-scope-tab"],
            });
            queryClient.invalidateQueries({
                queryKey: ["frontend-organization-scopes"],
            });
            queryClient.invalidateQueries({
                queryKey: ["frontend-organization-recent-scopes"],
            });
            queryClient.invalidateQueries({
                queryKey: ["frontend-scope-clauses", scopeClause.scope_id],
            });
            // Invalidate V2 topics with clauses query
            queryClient.invalidateQueries({
                queryKey: ["scope-topics-with-clauses", scopeClause.scope_id],
            });
        },
        onError: () => {
            enqueueSnackbar("An error occurred while updating the guidance", {
                variant: "error",
            });
        },
    });

    const handleRemove = () => {
        const payload: IConfirmationDialogProps = {
            title: scopeClause.clause.title,
            description:
                "Are you sure you want to remove the guidance for this clause? This action cannot be undone.",
            confirmText: "Remove",
            destructive: true,
            onConfirm: () => {
                mutate("");
            },
        };

        open(ConfirmationDialog, payload);
    };
    return (
        <Link
            component={"button"}
            variant="caption"
            color="error"
            onClick={handleRemove}
        >
            Remove Guidance
        </Link>
    );
};
